import React, { useEffect, useState, Fragment, useRef } from 'react';
import Button from '@material-ui/core/Button';
import MaterialMenu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { IuserInfo, IwarehouseList } from 'reducers/shareData/types';

import makeStyles from '@material-ui/core/styles/makeStyles';
import { IapiReponse } from 'main_type';
import {
  findOutRUL,
  getLoginInfo,
  getLoginInfoGuest,
  getLoginInfoGuest2,
  getWarehouse,
  logout,
} from '../../main_api';
import { IbtnRef } from './type';
import { getUserInfoRedux } from '../../reducers/shareData/selector';
import {
  setLoadingRedux,
  setUserInfoRedux,
  setWareHouseListRedux,
} from '../../reducers/shareData/action';

export interface IMenu {
  guest?: boolean;
}
const Menu = (props: IMenu): JSX.Element => {
  const { guest = false } = props;
  const [isGuest, setIsGuest] = useState(guest);
  // set Redux
  const dispatch = useDispatch();
  // get Redux
  const { menus } = useSelector(getUserInfoRedux);

  // useState
  const [activeMenu, setActiveMenu] = useState<string>('');

  const btnRef = useRef<IbtnRef>({});
  const filterWarehouseData = (
    type: string,
    data: IwarehouseList[]
  ): IwarehouseList[] => {
    switch (type) {
      // SFD(海運承攬業)、AFD(空運承攬業)
      case 'SFD':
      case 'AFD':
        return data.filter((v) => v.chkCode1 !== '');
      default:
        return data;
    }
  };
  // other
  const init = async () => {
    dispatch(setLoadingRedux(true));
    const loginData = await getLoginInfo();
    let WareHouseList;
    // console.log('isGuest', isGuest);
    // 2250  WareHouseList = await getWarehouse();  只能有登入使用

    // if (isGuest) {
    //   const [, appName] = window.location.pathname.split('/');
    //   console.log(appName);
    //   if (appName === 'InvoiceQry') {
    //     console.log('InvoiceQry');
    //     loginData = await getLoginInfoGuest();
    //   } else if (appName === 'CarRegisterMtn') {
    //     console.log('CarRegisterMtn');
    //     loginData = await getLoginInfoGuest2();
    //   } else {
    //     console.log('no  loginData');
    //     loginData = await getLoginInfo();
    //   }
    // } else {
    //   console.log('loginData');
    //   loginData = await getLoginInfo();
    // }

    console.log('loginData');
    const { user, userType } = loginData.data.data as IuserInfo;
    dispatch(setLoadingRedux(false));
    dispatch(setUserInfoRedux(loginData.data.data as IuserInfo));
    // const tax = user.id.split('_')[1];

    const id = user.id.split('_')[2] || '';
    user.id = id || '';

    if (!isGuest) {
      WareHouseList = await getWarehouse();
      const result = filterWarehouseData(
        userType,
        WareHouseList.data.data as IwarehouseList[]
      );
      dispatch(setWareHouseListRedux(result));
    }

    // #endregion
  };

  const handleClick = (id: string) => () => {
    setActiveMenu(id);
  };

  const handleOutURL = async (id: string) => {
    const result = await findOutRUL({ id });
    const outURL = result.data.data as string;
    if (outURL) {
      window.open(outURL, '_top');
    }
  };

  const handleClose = () => {
    setActiveMenu('');
  };

  const logoutClick = async () => {
    window.opener = null;
    await logout();
    // await logoutOut();
    window.location.href = '/login';
  };

  // useEffect
  useEffect(() => {
    init();
  }, []);

  const classes = makeStyles(() => ({
    root: {
      '& .MuiList-padding': {
        padding: 0,
      },
    },
  }))();
  return (
    <>
      <div>
        {!!menus &&
          menus.map((v) => (
            <Fragment key={v.id}>
              <Button
                style={{
                  color: '#0000C6',
                  fontSize: '1.5rem',
                  fontWeight: 900,
                  paddingTop: 0,
                  paddingBottom: 0,
                }}
                ref={(ref) => {
                  btnRef.current[v.id] = ref;
                }}
                onClick={handleClick(v.id)}
              >
                {v.chineseName}
              </Button>

              <MaterialMenu
                className={classes.root}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
                getContentAnchorEl={null} // 錨點
                keepMounted
                anchorEl={btnRef.current[v.id] || null}
                open={activeMenu === v.id}
                onClose={() => handleClose()}
              >
                {v.items &&
                  v.items.map((item) => (
                    <MenuItem
                      style={{ minHeight: '35px' }}
                      key={item.id}
                      onClick={() =>
                        item.id === 'WEHU709' || item.id === 'WEHU710'
                          ? handleOutURL(item.id)
                          : handleClose()
                      }
                      component={Link}
                      to={item.url || ''}
                    >
                      {item.chineseName}
                    </MenuItem>
                  ))}
              </MaterialMenu>
            </Fragment>
          ))}
      </div>
      <div>
        <Button
          color="primary"
          onClick={logoutClick}
          style={{
            fontWeight: 800,
            fontSize: '1.2rem',
          }}
        >
          登出
        </Button>
      </div>
    </>
  );
};

export default Menu;
